/* APIZ size data comes only from this product's existing description. */
(() => {
  function extract(text) {
    const normalized=text.normalize('NFKC');
    const explicit=normalized.match(/【\s*(?:size|サイズ)\s*】([\s\S]*?)(?=【|$)/i)?.[1]?.trim();
    if(explicit)return explicit;
    // Older descriptions occasionally omit the Size heading. Exclude model height.
    return normalized.match(/(◆\s*(?:着丈|総丈|胸囲|ウエスト|ヒップ|肩幅|袖丈|裄丈)[\s\S]*?)(?=【|$)/)?.[1]?.trim() || '';
  }
  function parse(text) {
    const source=extract(text), body=source.split(/※/)[0].trim();
    if (!body) return null;
    const groups=new Map(); let part='',size='ONE SIZE',unparsed=false;
    const tokens=body.replace(/\(([^()]*)\)/g,(whole,label)=>/^(?:[2-5]?X{0,3}[SML]|FREE|ONE\s*SIZE|フリー|Tシャツ|メッシュトップ|カットソー|ドレス|ミニドレス|メッシュドレス|インナードレス|ジャケット|スカート|トップス|パンツ|ベスト|ブラウス|セーター|シャツ|ショートパンツ|ロングパンツ)$/i.test(label.trim())?'\n@'+label.trim()+'\n':whole).replace(/◆/g,'\n◆').split('\n').map(t=>t.trim()).filter(Boolean);
    const bareSizes=[]; const measures=[];
    for (const token of tokens) {
      if (token.startsWith('@')) {
        const label=token.slice(1);
        if (/^(?:[2-5]?X{0,3}[SML]|FREE|ONE\s*SIZE|フリー)$/i.test(label)) size=label;
        else part=label;
        continue;
      }
      if (!token.startsWith('◆')) { unparsed=true; continue; }
      const value=token.slice(1).trim();
      if (/^\d+(?:\.\d+)?\s*cm$/i.test(value)) { bareSizes.push(value); continue; }
      const match=value.match(/^([^\d—]+?)\s*([\d—][\s\S]*)$/) || value.match(/^(.+?)\s+(調整可(?:能)?)$/);
      if (!match) { unparsed=true; continue; }
      const label=match[1].trim(), measurement=match[2].trim();
      if (!/cm|㎝|mm|kg|%|号|インチ|寸|^—$|^調整可/i.test(measurement)) { unparsed=true; continue; }
      if (!groups.has(part)) groups.set(part,new Map());
      const rows=groups.get(part);
      if(!rows.has(size)) rows.set(size,new Map());
      if(rows.get(size).has(label)) { unparsed=true; continue; }
      rows.get(size).set(label,measurement); measures.push(measurement);
    }
    const tables=[];
    if(bareSizes.length) {
      const all=[...groups.values()].flatMap(rows=>[...rows.values()].flatMap(row=>[...row]));
      if(groups.size>1||[...groups.values()].some(rows=>rows.size>1))unparsed=true;
      tables.push({id:'0',titleJa:'',titleEn:'',type:'accessory',columns:[{id:'size',ja:'サイズ',en:'Size',kind:'display'},...all.map(([label],i)=>({id:String(i),ja:label,en:label,kind:'display'}))],rows:bareSizes.map(v=>[v,...all.map(([,m])=>m)])});
    } else for(const [name,rows] of groups){
      const labels=[...new Set([...rows.values()].flatMap(row=>[...row.keys()]))];
      tables.push({id:String(tables.length),titleJa:name,titleEn:name,type:'tops',columns:[{id:'size',ja:'サイズ',en:'Size',kind:'label'},...labels.map((label,i)=>({id:String(i),ja:label,en:label,kind:'display'}))],rows:[...rows].map(([label,row])=>[label,...labels.map(key=>row.get(key)||'—')])});
    }
    return {source,body,tables:unparsed?[]:tables,type:bareSizes.length?'accessory':'tops',unparsed};
  }
  // Exposed only as a pure parser for regression checks and section reloads.
  if(typeof module!=='undefined'&&module.exports){module.exports={parse,extract};return;}
  function init(){
    document.querySelectorAll('apiz-product').forEach(product=>{
      const host=product.querySelector('[data-londa-size-guide]');
      if(!host||host.querySelector('script'))return;
      const description=product.querySelector('[data-apiz-description]');
      if(!description)return;
      const copy=description.cloneNode(true);copy.querySelectorAll('br').forEach(el=>el.replaceWith('\n'));copy.querySelectorAll('p,div,li,tr,h2,h3').forEach(el=>el.append('\n'));
      const data=parse(copy.textContent); if(!data)return;
      const button=product.querySelector('[data-lpd-open-size]');if(button)button.hidden=false;
      if(data.tables.length||!button){const script=document.createElement('script');script.type='application/json';script.textContent=JSON.stringify({version:1,type:data.type,unit:'cm',tableOrderOverride:true,tables:data.tables,sourceText:data.tables.length?'':data.source});host.append(script);}
      else {
        const dialog=document.createElement('dialog');dialog.className='lpd-dialog apiz-size-fallback';dialog.setAttribute('aria-label','サイズガイド');
        const top=document.createElement('div');top.className='lpd-sheet-heading';const title=document.createElement('h2');title.textContent='APIZ — サイズガイド';const close=document.createElement('button');close.type='button';close.className='lpd-icon-button';close.textContent='×';close.setAttribute('aria-label','閉じる');close.onclick=()=>dialog.close();top.append(title,close);
        const name=document.createElement('h3');name.textContent=product.data?.title||host.dataset.productTitle;const content=document.createElement('div');content.className='apiz-size-original';content.textContent=data.source;dialog.append(top,name,content);product.append(dialog);product.apizSizeDialog=dialog;dialog.addEventListener('close',()=>{product.sizeGuideOpen=false;button.focus();product.updateMediaPlayback?.();});dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
      }
    });
  }
  init();document.addEventListener('shopify:section:load',init);
})();

